import { Card, CardContent } from '@/components/base/Card';
import { ConsultationScrollArea } from '@/components/consultation/ConsultationScrollArea';
import type { VitalSigns } from '@/lib/types/consultation';

export interface GeneralExaminationCardProps {
  vitals?: VitalSigns | null;
}

function VitalRow({
  label,
  value,
  unit,
  note,
}: {
  label: string;
  value?: string | number | null;
  unit?: string;
  note?: string;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-2xl bg-[#F8F8F1] px-4 py-1">
      <div className="flex items-center justify-between gap-2">
        <span className="font-hanken text-base font-medium text-[#42434B]">{label}</span>
        <span className="font-hanken text-sm text-[#585859]">
          {value !== undefined && value !== null && value !== '' ? `${value}${unit ?? ''}` : '—'}
        </span>
      </div>
      {note && <span className="font-hanken text-sm text-[#585859]">{note}</span>}
    </div>
  );
}

export function GeneralExaminationCard({ vitals }: GeneralExaminationCardProps) {
  return (
    <Card padding="none" className="h-full overflow-hidden rounded-[24px] border-white bg-white">
      <ConsultationScrollArea className="h-full">
        <CardContent className="flex flex-col gap-4 p-4">
          <h2 className="font-serif text-[calc(20px*var(--app-scale))] font-normal leading-[30px] text-[#3C4F1E]">
            General Examination
          </h2>
          <div className="flex flex-col gap-2">
            <VitalRow label="Pulse Rate" value={vitals?.heartRate} unit=" bpm" />
            <VitalRow label="Respiratory Rate" value={vitals?.respiratoryRate} unit=" /min" />
            <VitalRow label="Blood Pressure" value={vitals?.bloodPressure} unit=" mmHg" />
            <VitalRow label="Temperature" value={vitals?.temperature} unit="°F" />
            <VitalRow label="Height" value={vitals?.height} unit=" cm" />
            <VitalRow label="Weight" value={vitals?.weight} unit=" kg" />
          </div>
        </CardContent>
      </ConsultationScrollArea>
    </Card>
  );
}
